export default "__VITE_ASSET__DpcfhsM4__"